// @flow

import { ReducerRegistry } from "../../../base/redux";
import * as actionTypes from "../../actionTypes";

const STORE_NAME = "jistimeet_settings";

const DEFAULT_STATE = {
    meetings_settings: [],
    invitation_list: [], 
};

ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
        switch (action.type) {
        case actionTypes.MEETINGS_SETTINGS:
            return {
                ...state,
                meetings_settings: action.payload,
            };           
        case actionTypes.INVITATION_LIST:
            return {
                ...state,
                invitation_list: action.payload,
            };     
        default:
            return state;
    }
});
